import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { LinearProgress, useDataProvider } from "react-admin";
import { useRenderCounter } from "./renderCounter";

export const WithData = ({
  url,
  method = "GET",
  render,
  notify = () => null,
  successMessage = "",
}) => {
  useRenderCounter("WithData");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [data, setData] = useState();

  const dataProvider = useDataProvider();

  useEffect(() => {
    let isActive = true;

    setLoading(true);
    setError(undefined);
    setData(undefined);

    dataProvider
      .customCommand(url, notify, method, successMessage)
      .then((response) => {
        if (!isActive) return;
        setData(response);
      })
      .catch((err) => {
        if (!isActive) return;
        setError(err);
      })
      .finally(() => {
        if (!isActive) return;
        setLoading(false);
      });

    return () => {
      isActive = false;
    };
  }, [dataProvider, url, method, successMessage]);

  if (loading) return <LinearProgress />;
  if (error) return <Box className="error">ERROR: {error.message}</Box>;
  if (!data) return <Box>No data</Box>;

  return render(data);
};
